import React, { useEffect, useMemo, useState } from 'react';
import Drawer from 'rc-drawer';
import 'rc-drawer/assets/index.css';
import '../addonService.scss';
import { Button } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import AddonSection from './AddonSection';
import { getMaxQuantity, categorizeAddons } from './utils';
import { ADD_ON_FEE_TYPE_VALUE } from '../../../containers/settings/AddonTemplate/utils/fieldAddonService';
import { isMobile } from 'react-device-detect';
const AddonDrawer = ({
  open,
  onClose,
  addonServices = [],
  onSetAddOnServicesSelected,
  isEditFare = false,
  currencyISO,
  disabled = false,
  auth = {}
}) => {
  const [localSelected, setLocalSelected] = useState(addonServices || []);

  useEffect(() => {
    if (open) {
      if (!addonServices) return;
      setLocalSelected(addonServices);
    }
  }, [open, addonServices]);

  const handleClose = () => {
    setLocalSelected([]);
    onClose();
  };

  const handleSave = () => {
    onSetAddOnServicesSelected(localSelected);
    handleClose();
  };

  const categorize = useMemo(
    () => categorizeAddons(addonServices),
    [addonServices]
  );

  const findEntry = (serviceId) =>
    localSelected?.find((item) => item.serviceId === serviceId);

  const upsertEntry = (service, updater) => {
    setLocalSelected((prev) => {
      const next = [...prev];
      const idx = next.findIndex(
        (item) => item.serviceId === service.serviceId
      );
      const base = {
        serviceId: service.serviceId,
        globalAttributeId: service.globalAttributeId ?? null,
        name: service.name,
        description: service.description || '',
        quantity: 0,
        enabled: false,
        feeConfig: service.feeConfig,
      };
      const current = idx >= 0 ? next[idx] : base;
      const updated = updater(current);
      if (idx >= 0) {
        next[idx] = updated;
      } else {
        next.push(updated);
      }
      return next;
    });
  };

  const handleQuantityChange = (service, delta) => {
    const maxQuantity = getMaxQuantity(service);
    const currentQuantity = findEntry(service.serviceId)?.quantity || 0;
    const proposed = Math.max(service?.isRequired ? 1 : 0, currentQuantity + delta);
    const nextQuantity = Number.isFinite(maxQuantity)
      ? Math.min(proposed, maxQuantity)
      : proposed;

    upsertEntry(service, (current) => ({
      ...current,
      quantity: nextQuantity,
      enabled: service?.isRequired ? true : nextQuantity > 0,
    }));
  };

  const handleValueEditFareChange = (service, value) => {
    const numeric = value === '' ? undefined : Number(value);
    upsertEntry(service, (current) => {
      const valueFinal = Number.isNaN(numeric) ? current.customValue : numeric;
      const newService = {
        ...service,
        enabled: valueFinal > 0,
      };
      // if(service?.feeConfig?.type === ADD_ON_FEE_TYPE_VALUE.custom) {
      // } else {
      // }
      newService.customValue = valueFinal;
      newService.editedValue = valueFinal;
      return newService;
    });
  };

  const handleCustomValueChange = (service, value) => {
    const numeric = value === '' ? undefined : Number(value);
    upsertEntry(service, (current) => {
      const valueFinal = Number.isNaN(numeric) ? current.customValue : numeric;
      return {
        ...current,
        customValue: valueFinal,
        enabled: valueFinal > 0,
      };
    });
  };

  return (
    <Drawer
      open={open}
      onClose={handleClose}
      placement="right"
      width={isMobile ? '90%' : 500}
      closable={false}
      maskClosable={false}
      className="addon-drawer"
      zIndex={10000}
    >
      <div className="addon-drawer__content">
        <div className="addon-selection">
          <AddonSection
            title="Add-Ons (Included)"
            items={categorize.included}
            hideEnableButton={true}
            hideDivider={true}
            isIncluded={true}
            findEntry={findEntry}
            onQuantityChange={handleQuantityChange}
            onValueEditFareChange={handleValueEditFareChange}
            isEditFare={isEditFare}
            currencyISO={currencyISO}
            disabled={disabled}
            auth={auth}
          />
          <AddonSection
            title="Add-Ons (Compulsory)"
            items={categorize.compulsory}
            hideEnableButton={true}
            findEntry={findEntry}
            onQuantityChange={handleQuantityChange}
            onCustomValueChange={handleCustomValueChange}
            onValueEditFareChange={handleValueEditFareChange}
            isEditFare={isEditFare}
            currencyISO={currencyISO}
            disabled={disabled}
            auth={auth}
          />
          <AddonSection
            title="Add-Ons (Optional)"
            items={categorize.optional}
            findEntry={findEntry}
            onQuantityChange={handleQuantityChange}
            onCustomValueChange={handleCustomValueChange}
            onValueEditFareChange={handleValueEditFareChange}
            isEditFare={isEditFare}
            currencyISO={currencyISO}
            disabled={disabled}
            auth={auth}
          />
        </div>
        <div className="addon-drawer__footer">
          <Button className=" mr-3 btn-header" style={{color: '#f52c18'}} onClick={handleClose}>
            <Translate value="addon.Cancel" />
          </Button>
          {
            !disabled && (
              <Button className="btn-save" onClick={handleSave}>
                <Translate value="addon.Save" />
              </Button>
            )
          }
        </div>
      </div>
    </Drawer>
  );
};

export default AddonDrawer;

